import { render } from "./ServiceDetail.vue?vue&type=template&id=2edd4af3"
import script from "./ServiceDetail.vue?vue&type=script&lang=js"
export * from "./ServiceDetail.vue?vue&type=script&lang=js"

import "./ServiceDetail.vue?vue&type=style&index=0&id=2edd4af3&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__